// extracted by mini-css-extract-plugin
export var border = "_1a-7";
export var brand = "_1a-r";
export var button = "_1a-j";
export var center = "_1a-9";
export var centered = "_1a-5";
export var closeButton = "_1a-b";
export var disabledWrapper = "_1a-k";
export var error = "_1a-n";
export var extraLarge = "_1a-4";
export var extraSmall = "_1a-1";
export var fill = "_1a-g";
export var footer = "_1a-f";
export var footerAction = "_1a-h";
export var footerButtons = "_1a-i";
export var header = "_1a-6";
export var icon = "_1a-m";
export var info = "_1a-q";
export var inline = "_1a-8";
export var large = "_1a-3";
export var main = "_1a-c";
export var modal = "_1a-0";
export var neutral = "_1a-s";
export var noPadding = "_1a-e";
export var none = "_1a-t";
export var scrollable = "_1a-d";
export var small = "_1a-2";
export var success = "_1a-p";
export var tight = "_1a-l";
export var titleIcon = "_1a-a";
export var warn = "_1a-o";